import { EPaginationActionTypes } from '../../actions/pagination';
import { EPromosActionTypes } from '../../actions/promos';
import { mapListingsUrls } from '../../mappers';
import { IListingsUrls } from '../../types/listingsUrls';
import { TReduxActions } from '../../types/redux';

const defaultState: IListingsUrls = {
  mapUrl: null,
  listingUrl: null,
};

export function listingsUrlsReducer(state: IListingsUrls = defaultState, action: TReduxActions) {
  if (action.type === EPromosActionTypes.Success || action.type === EPaginationActionTypes.Success) {
    return mapListingsUrls(action.payload);
  }

  return state;
}
